<template>
  <div class="home-personal">
    <HomeTab v-if="activeTab === 'home'" />
    <MineTab v-else-if="activeTab === 'mine'" />
    <van-tabbar v-model="activeTab">
      <van-tabbar-item name="home" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item name="mine" icon="friends-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { reactive, toRef, onMounted } from 'vue'
import globalVariables from '@/utils/globalVariables'
import useWechat from '@/utils/useWechat'
import HomeTab from './components/HomeTab'
import MineTab from './components/MineTab'

export default {
  components: {
    HomeTab,
    MineTab
  },
  setup() {
    globalVariables.setProjectCode(100101)
    const data = reactive({
      activeTab: 'home'
    })
    useWechat()

    onMounted(() => {
      document.title = ''
    })

    return {
      activeTab: toRef(data, 'activeTab')
    }
  }
}
</script>

<style lang="less" scoped>
.home-personal {
  .van-tabbar-item--active {
    color: red;
  }
}
</style>
